import React from 'react';
import EventOverviewContainer from 'features/EventOverviewContainer';

const EventOverview = (props) => {
  return (
    <EventOverviewContainer {...props} />
  );
};

export default EventOverview;